module.exports = __webpack_public_path__ + "img/OrgChartTemp5.232f41d0.png";